import React, { useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';

interface QRScannerProps {
  onScan: (data: string) => void;
  onCancel: () => void;
}

const QRScanner: React.FC<QRScannerProps> = ({ onScan, onCancel }) => {
  const { t } = useTranslation();
  const [isScanning, setIsScanning] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleScan = () => {
    setIsScanning(true);
    setError(null);
    
    // Simulate QR scanning for now
    // In a real implementation, you would use a QR scanner library
    setTimeout(() => {
      // Mock QR code data
      const mockQRData = 'https://app.com/checkin/client-uuid-123/1234567890';
      onScan(mockQRData);
    }, 2000);
  };

  const handleManualInput = () => {
    const input = prompt(t('enterQRCodeManually'));
    if (input) {
      onScan(input);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            {t('scanQRCode')}
          </h2>
          
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}
          
          <div className="bg-gray-100 rounded-lg p-8 mb-4">
            {isScanning ? (
              <div className="space-y-4">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
                <p className="text-gray-600">{t('scanning')}...</p>
              </div>
            ) : (
              <div className="space-y-4">
                <svg className="h-16 w-16 text-gray-400 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                </svg>
                <p className="text-gray-600">{t('pointCameraAtQRCode')}</p>
              </div>
            )}
          </div>
          
          <div className="space-y-3">
            <button
              onClick={handleScan}
              disabled={isScanning}
              className="btn-primary w-full"
            >
              {isScanning ? t('scanning') : t('startScanning')}
            </button>
            
            <button
              onClick={handleManualInput}
              disabled={isScanning}
              className="btn-secondary w-full"
            >
              {t('enterManually')}
            </button>
            
            <button
              onClick={onCancel}
              disabled={isScanning}
              className="btn-secondary w-full"
            >
              {t('cancel')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRScanner; 